export default __webpack_public_path__ + "static/favorites-empty-c5ebe5c6288526110246b173c9318688.jpeg";